export default function appendFacebookPlaceholderNode() {
  if (!document.getElementById('fb-root')) {
    var node = document.createElement('div');
    node.id = 'fb-root';
    document.body.appendChild(node);
  }
}